import { render, staticRenderFns } from "./create.vue?vue&type=template&id=fccd8f2a&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=fccd8f2a&prod&lang=css&scoped=true"
import style1 from "./create.vue?vue&type=style&index=1&id=fccd8f2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd8f2a",
  null
  
)

export default component.exports